/* eslint-disable no-console */

/**
 * This is a custom hook that helps to store data in the local storage.
 * @param key is the key to store the data in the local storage.
 * @returns functions to get, set and remove the value from the local storage.
 */
function useLocalStorage<T>(key: string) {

	/**
	 * Used to get the value of the key
	 * @returns the value stored in the local storage.
	 */
	function getValue() {
		try {
			const item = window.localStorage.getItem(key);
			return item ? (JSON.parse(item) as T) : null;
		} catch (error) {
			console.error(error);
			return null;
		}
	}

	/**
	 * Used to set the value of the key
	 * @param value is the value to be stored in the local storage.
	 */
	const setValue = (value: T) => {
		try {
			window.localStorage.setItem(key, JSON.stringify(value));
		} catch (error) {
			console.error(error);
		}
	};

	/**
	 * Used to remove the value of the key
	 */
	const removeValue = () => {
		try {
			window.localStorage.removeItem(key);
		} catch (error) {
			console.error(error);
		}
	};

	return { value: getValue(), setValue, getValue, removeValue };
}

export default useLocalStorage;
